import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_6: FaireProductEntity = {
  token: "nyc-snack-6",
  type: "product",
  name: "Artisan Granola Mix",
  brandName: "Astoria Granola Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1f5fc70299bc5e6af6328c56ce5a6715af841aaa37d9002be999bf81d53d7624.webp",
  priceDollars: 13,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/1f5fc70299bc5e6af6328c56ce5a6715af841aaa37d9002be999bf81d53d7624.webp",
  weight: 0.7,
  dimensions: {
    width: 5,
    height: 7,
    depth: 2,
  },
  description: "Handmade granola with organic oats, nuts, and honey",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "organic", "breakfast"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
